const splitTitle = (t) => {
  const i = t.indexOf(":");
  return i === -1 ? [t, ""] : [t.slice(0, i + 1), t.slice(i + 1).trim()];
};

export const Hero = ({ ev, ctaHref, ctaTestId, testid }) => {
  const [main, sub] = splitTitle(ev.title);
  const ctaLabel = ev.coming_soon ? "See the dates" : "Reserve your seat";
  return (
    <section className="relative flex min-h-[520px] items-center overflow-hidden bg-[#141210] sm:min-h-[600px]" data-testid={testid}>
      {ev.image && <img src={ev.image} alt="" className="absolute inset-0 h-full w-full object-cover" />}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(20,18,16,0.35),rgba(20,18,16,0.75))]" />
      <div className="relative mx-auto max-w-4xl px-5 py-24 text-center">
        {ev.eyebrow && <p className="reveal text-[11px] font-extrabold uppercase tracking-[0.25em] text-white/90">{ev.eyebrow}</p>}
        <h1 className="reveal reveal-2 mt-5 font-display text-4xl leading-[1.08] text-white drop-shadow-lg sm:text-5xl lg:text-6xl" data-testid="event-title">
          {main}{sub && <em className="block text-[#E8C878]">{sub}</em>}
        </h1>
        {ev.tagline && <p className="reveal reveal-3 mx-auto mt-6 max-w-xl text-base text-white/90 drop-shadow md:text-lg">{ev.tagline}</p>}
        <a href={ctaHref} data-testid={ctaTestId}
          className="reveal reveal-4 mt-9 inline-block rounded border border-[#C9A24B] bg-[#141210]/80 px-8 py-4 text-xs font-extrabold uppercase tracking-[0.2em] text-[#F3DDA4] transition-colors duration-200 hover:bg-[#C9A24B] hover:text-[#141210]">
          {ctaLabel}
        </a>
        {ev.schedule_note && <p className="reveal reveal-4 mt-5 text-sm text-white/75">{ev.schedule_note}</p>}
      </div>
    </section>
  );
};
